import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/bcwin-prod/site_front/src/app/[locale]/template.tsx");
